module.exports = __webpack_public_path__ + "static/media/icon-trapezoid-delete.5dbc5d18.svg";